import ChapterSettingsFormContainer from './ChapterSettingsFormContainer';

export default ChapterSettingsFormContainer;
